import { useState, useEffect } from "react";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, FileSignature, Download } from "lucide-react";

const fmt = (d) => { try { return new Date(d).toLocaleString(); } catch { return d; } };

export function MyAgreements() {
    const [sigs, setSigs] = useState(null);
    const [current, setCurrent] = useState(null);
    const [busy, setBusy] = useState("");
    useEffect(() => {
        api.get("/me/agreements").then((r) => setSigs(r.data.signatures)).catch(() => setSigs([]));
        api.get("/agreements/service_agreement").then((r) => setCurrent(r.data.agreement)).catch(() => {});
    }, []);
    if (!sigs) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-teal" /></div>;

    const download = async (s) => {
        setBusy(s.id);
        try {
            const r = await api.get(`/me/agreements/${s.id}/pdf`, { responseType: "blob" });
            const url = URL.createObjectURL(r.data); const a = document.createElement("a");
            a.href = url; a.download = `agreement-${s.slug}-v${s.version}.pdf`; a.click(); URL.revokeObjectURL(url);
        } catch { toast.error("Could not download PDF"); } finally { setBusy(""); }
    };

    return (
        <div className="space-y-6" data-testid="my-agreements">
            <div className="glass-card rounded-2xl p-6">
                <div className="flex items-center gap-2 font-heading text-xl font-bold text-navy"><FileSignature className="h-5 w-5 text-teal" /> My Agreements</div>
                <p className="mt-1 text-sm text-slate-500">Every agreement you've signed electronically, with a downloadable PDF copy. {current && <>Current Service Agreement version: <b className="text-navy">v{current.version}</b>.</>}</p>
            </div>
            {sigs.length === 0 ? (
                <div className="glass-card rounded-2xl p-12 text-center text-slate-500" data-testid="my-agreements-empty">No signed agreements yet. You'll sign the Service Agreement when you request a program consultation.</div>
            ) : sigs.map((s) => {
                const isCurrent = current && s.slug === current.slug && s.version === current.version;
                return (
                    <div key={s.id} className="glass-card flex flex-wrap items-center gap-4 rounded-2xl p-5" data-testid={`my-agreement-${s.id}`}>
                        <div className="flex-1">
                            <div className="flex flex-wrap items-center gap-2"><span className="font-heading font-bold text-navy">{s.slug.replace(/_/g, " ")}</span><Badge className={isCurrent ? "bg-teal/15 text-teal hover:bg-teal/15" : "bg-slate-100 text-slate-600 hover:bg-slate-100"}>v{s.version}{isCurrent ? " · current" : " · superseded"}</Badge></div>
                            <div className="mt-1 text-sm text-slate-500">Signed as <b className="text-slate-700">{s.full_name}</b> · {fmt(s.signed_at)}</div>
                        </div>
                        <button onClick={() => download(s)} disabled={busy === s.id} data-testid={`my-agreement-pdf-${s.id}`} className="inline-flex h-10 items-center gap-2 rounded-full bg-navy px-4 text-sm font-semibold text-white hover:bg-ocean disabled:opacity-60">
                            {busy === s.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Download className="h-4 w-4" /> Download PDF</>}
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
